import * as actions from '../constants/actions'
import { createActionCreator } from '../utils/redux'

const LAYOUT_WIDTH_LIMIT = 800

export function windowResize() {
	return function(dispatch, getState) {
		const oldLayout = getState().layout
		const newLayout = window.innerWidth < LAYOUT_WIDTH_LIMIT ? 'NARROW' : 'WIDE'
		if (oldLayout !== newLayout) {
			dispatch(changeLayout(newLayout))
		}
	}
}

export const changeLayout = createActionCreator(actions.CHANGE_LAYOUT, 'layout')


// WEBPACK FOOTER //
// ./src/actionCreators/windowResize.js